import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeactivateRouteService } from 'src/modules/appointment/searchDoctor/popupBeforeExit/deactivate-route.service';
import BaseDecorator from 'src/modules/base/base-decorator';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PrintService } from 'src/modules/base/shared/services/print.service';

@Component({
    selector: 'app-duty-roaster',
    templateUrl: './duty-roaster.component.html',
    styleUrls: ['./duty-roaster.component.scss'],
    standalone: false
})
export class DutyRoasterComponent extends BaseDecorator implements OnInit {
  @ViewChild("editGrid") someInput: Component;
  config: any;
  resourceDef: any;
  dateFields: any;
  formValue: any;
  action: any;
  headingArray = [];
  shiftList: any;
  changedResource: any;
  isLoaded: boolean = false;
  gridConfig: any = {};
  container: any = {};
  month: number;
  year: number;
  dutyRoster: any = {};
  editGridResource: any = 'duty_roaster_edit_grid';
  getData: any;
  dataConfig: any;
  self: this;
  GridData: {};
  autoFillItem: any = [];
  currentDate: any;
  currentMonth: any;
  currentYear: any;
  startIteration: any;
  endIteration: any;
  filterDate: any = {};
  defaultData: any;
  datesBetween: Date[] = [];

  constructor(
    public baseService: BaseService,
    public loader: LoaderService,
    public alertService: AlertsService,
    public route: ActivatedRoute,
    public router: Router,
    public printService: PrintService,
    public appService: AppService,
    public communicationService: CommunicationService,
    public deactiveService: DeactivateRouteService,
    public utilService: UtilService,
    public dialogService?: DialogService,
  ) {
    super(route, 'DutyRoasterComponent');
    this.self = this;
  }

  ngOnInit(): void {
    let currentDate = new Date();;
    this.currentDate = currentDate.getDate();
    this.currentYear = currentDate.getFullYear();
    this.currentMonth = currentDate.getMonth();
    this.config = {
      "submitButton": false,
      "cancelButton": false,
      "filterForm": false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.dataConfig = {
      "submitButton": true,
      "cancelButton": true,
      "filterForm": false,
      "clearOnSave": false,
      "delegateSave": true,
      "hideSearchBox": true,
      "allowPagination": true,
      "customButtonsAllowed": true,
      "search": false
    }
    if (this.router.url.indexOf('duty_roaster_update') > -1) {
      this.action = 'DUTY_';
      this.getData = JSON.parse(sessionStorage.currentData);
      this.shiftAutoFill(this.getData);
      this.baseService.getResourceDef('duty_roaster_update', (data) => {
        this.resourceDef = data;
      })
    }
    else if (this.router.url.indexOf('duty_roaster_add') > -1) {
      this.action = 'DUTY_ROSTER_CREATION';
      this.configDate();
      this.baseService.getResourceDef('duty_roaster', (data) => {
        this.resourceDef = data;
      })
    }
    else if (this.router.url.indexOf('duty_roaster_shift_change') > -1) {
      this.action = "SHIFT_CHANGE"
      this.getData = JSON.parse(sessionStorage.currentData);
      if (this.currentMonth > new Date(this.getData.month).getMonth()) {
        this.alertService.error("Cannot change shift for previous month");
      }
      else {
        this.shiftAutoFill(this.getData)
        this.editGridResource = 'ward_transfer_edit_grid';
        this.baseService.getResourceDef('duty_roster_shift_change', (data) => {
          this.resourceDef = data;
        })
      }
    }
    else if (this.router.url.indexOf('duty_roaster_ward_transfer') > -1) {
      this.action = "WARD_CHANGE"
      this.getData = JSON.parse(sessionStorage.currentData);
      if (this.currentMonth > new Date(this.getData.month).getMonth()) {
        this.alertService.error("Cannot change ward for previous month");
      }
      else {
        this.editGridResource = 'ward_transfer_edit_grid';
        this.baseService.getResourceDef('duty_roster_nurse_wise', (data) => {
          this.resourceDef = data;
        })
      }
    }
    else if (this.router.url.indexOf('duty_roaster_view') > -1) {
      this.action = 'view';
      this.baseService.getResourceDef('duty_roster_print', (data) => {
        this.resourceDef = data;
      })
      let args = "destination:" + this.route.snapshot.params.id
      this.baseService.get("GET_ROASTER_BY_DESTINATION", args, "duty_roaster", "facility-management").subscribe((res) => {
        if (res.errCode == 0) {
          this.GridData = {}
          this.GridData['resource'] = res.resource[0].duty_roaster;
          this.GridData['count'] = res.resource[0].duty_roaster.length;
          this.dutyRoster.view = res.resource[0];
          this.dutyRoster.resource = res.resource[0].duty_roaster;
        }
      })
      this.dynamicFields();
    }
    this.defaultFormData(this.getData);
  }
  defaultFormData(getData: any) {
    if (this.action != 'DUTY_ROSTER_CREATION') {
      this.defaultData = getData;
    }
  }
  dynamicFields(event?) {
    this.headingArray = []
    if (event) {
      this.startIteration = this.getDate(event.FROM)
      this.endIteration = this.getDate(event.TO) + 1;
    }
    else {
      this.startIteration = 1;
      this.endIteration = this.getMonthDays(this.route.snapshot.params.data) + 1
    }
    for (let i = this.startIteration; i < this.endIteration; i++) {
      let heading = {
        "heading": this.getLabel(i, this.route.snapshot.params.data),
        "card_tag": null,
        "order": i + 2,
        "format": "fn=function(item){ return (item.shift_array.find(x=> x.date=='" + this.getLabel(i, this.route.snapshot.params.data) + "')['shift'])}",
        "type": "composite",
        "name": "shift_array",
        "class_conditions":
        {
          "expression": this.getLabel(i, this.route.snapshot.params.data),
        }
      }
      this.headingArray.push(heading)
    }
    let ob2 = {
      "heading": "Nurse",
      "card_tag": null,
      "order": 2,
      "sortable": true,
      "name": "nurse_name"
    }
    this.headingArray.unshift(ob2)
    let obj = {
      "heading": "Ward",
      "card_tag": null,
      "order": 1,
      "sortable": true,
      "name": "ward_name"
    }
    this.headingArray.unshift(obj)
  }
  configDate() {
    let facilityId = this.appService.getOrganization().org_id;
    let objRefer = {
      "application": "facility-management",
      "resource": "facility_config_mapping",
      "query_id": "GET_CONFIG",
      "args": "facility_id:" + facilityId + ",module_code:facility-management,config_code:duty_1"
    }
    this.baseService.getByDataSource(objRefer).subscribe((res) => {
      if (res.errCode == 0) {
        if (res.resource[0].config_value > this.currentDate) {
          this.alertService.error("Duty Roster creation can be done from date " + res.resource[0].config_value + " of month");
        }
      }
    })

  }
  shiftAutoFill(item) {
    if (this.action == 'SHIFT_CHANGE') {
      let obj = {};
      for (let i = 0; i < item.shift_array.length; i++) {
        if (item.shift_array[i].date.length == 5) {
          obj["leave_code" + item.shift_array[i].date[0]] = item.shift_array[i].shift
        }
        else
          obj["leave_code" + item.shift_array[i].date.substring(0, 2)] = item.shift_array[i].shift
      }
      obj["nurse_id"] = item["nurse_id"]
      this.autoFillItem.push(obj);
    }
    if (this.action == 'DUTY_') {
      for (let j = 0; j < item.duty_roaster.length; j++) {
        let obj = {};
        if (item.duty_roaster[j].shift_array) {
          for (let i = 0; i < item.duty_roaster[j].shift_array.length; i++) {
            if (item.duty_roaster[j].shift_array[i].date.length == 5) {
              obj["leave_code" + item.duty_roaster[j].shift_array[i].date[0]] = item.duty_roaster[j].shift_array[i].shift
            }
            else
              obj["leave_code" + item.duty_roaster[j].shift_array[i].date.substring(0, 2)] = item.duty_roaster[j].shift_array[i].shift
          }
        }
        obj["nurse_id"] = item.duty_roaster[j].nurse_id
        this.autoFillItem.push(obj);
      }
    }
  }

  setForm(form: any, action: any = "ADD") {
    if (this.action != 'DUTY_ROSTER_CREATION') {
      form.controls.department_id.setValue(this.getData.department_id);
      form.controls.wardType_id.setValue(this.getData.wardType_id);
      form.controls.wardType_name.setValue(this.getData.wardType_name);
      form.controls.month.setValue(this.getData.month);
      form.controls.ward_name.setValue(this.getData.ward_name);
      form.controls.ward_id.setValue(this.getData.ward_id);
      setTimeout(() => {
        form.controls.store_id.setValue(this.getData.store_id);
      }, 3000);
      if (this.action == 'WARD_CHANGE') {
        form.controls.des_wardType_id.setValue(this.getData.wardType_id);
        form.controls.des_wardType_name.setValue(this.getData.wardType_name);
        form.controls.nurse_name.setValue(this.getData.nurse_name);
        form.controls.nurse_id.setValue(this.getData.nurse_id);
      }
      if (this.action == 'SHIFT_CHANGE') {
        form.controls.nurse_name.setValue(this.getData.nurse_name);
        form.controls.nurse_id.setValue(this.getData.nurse_id);
        form.controls.month.setValue(this.getData.month);
      }
    }
  }

  listen_changes(e) {
    if (e != undefined && e.object != undefined && e.object.controls != undefined && e.object.controls["nurse_id"]) {
      if (e.object.controls["nurse_id"].value != "") {
        this.baseService.get("GET_BY_ID", "id:" + e.object.controls["nurse_id"].value, "practitioner_facility_details_other", "facility-management").subscribe((res) => {
          if (res.resource.length != 0) {
            e.object.controls["nurse_name"].setValue(res.resource[0].display_name);
            let filter = {
              "filter": "g_created_by_id:" + res.resource[0].practitioner_id,
              "page_no": 0,
              "page_size": 100
            }
            this.baseService.getData(filter, "", "leave_request", "crm", "GET_PAGE").subscribe(
              result => {
              if (result.resource.length != 0) {
                let obj = result.resource;
                console.log("res",res);
                obj.forEach(element => {
                    // Convert milliseconds to Date object
                    let start_date = new Date(element.leave_from_date);
                    let end_date = new Date(element.leave_to_date);
                      // Extract date part
                      let formattedStartDate = start_date.getDate();
                      let formattedEndDate = end_date.getDate();
                      console.log("formattedDate",formattedStartDate);
                      let field = "leave_code"
                      // let startfield = field+formattedStartDate;
                      // let endfield = field+formattedEndDate;
                      // console.log("field",field);
                      if(element.leave_code && this.month == start_date.getMonth()){;
                        // Iterate through each date until we reach the end date
                        while (start_date <= end_date) {
                          this.datesBetween.push(new Date(start_date));
                          let formattedDate = start_date.getDate();
                          let startfield = field+formattedDate;
                          console.log("field",field);
                          e.object.controls[startfield].setValue(element.leave_code);
                          e.object.controls[startfield]['question_component'].question.disabled = true;
                          start_date.setDate(start_date.getDate() + 1); // Move to the next day
                        }
                        console.log("this.datesBetween",this.datesBetween);
                        
                        // e.object.controls[startfield].setValue(element.leave_code);
                        // e.object.controls[endfield].setValue(element.leave_code);
                      }
                  });
                }
              }
            )

          }
        })
      }
      // else {
      //   this.nurse_name = e.question.options[0].display_name;
      // }
    }
  }
  // valueChangeStartEG(e: any, formObj: any = false) {
  //   console.log("valueChangeStart ", e);
  // }
  // valueChangeEndEG(e: any, formObj: any = false) {
  //   console.log("valueChangeStart ", e);
  // }
  getNurseData(event) {
    let obj = {
      args: `locationType:${event.form.value.wardType_id},location:${event.form.value.ward_name},department_id:${event.form.value.department_id}`
    }
    this.baseService.getData(obj, '', 'duty_roaster', 'facility-management', 'GET_NURSE_BY_WARD').subscribe((res) => {
      if (res && res.errCode == 0) {
        this.container.nurseData = res.resource;
      }
    })
  }
  getShiftLeave(item: any) {
    let argsShift = "status:active,department:" + item;
    this.baseService.get("GET_SHIFT_AND_LEAVE", argsShift, "duty_shift_master", "facility-management").subscribe((res) => {
      this.shiftList = res.resource
    })
  }
  prepareDynamicolumns(event) {
    if (this.container.dynamicColumns && this.container.dynamicColumns.length > 0) {
      let obj = {
        "label": "Staff Name",
        "getterKey": "id",
        "getterValue": "display_name",
        "class_name": "kx-control col-12",
        "order": 1,
        "type": "String",
        "component": "searchselect",
        "req_keys": [
          "display_name",
          "login_id",
          "id"
        ],
        "format": "(item) => `${item.display_name} ||  ${item.login_id}`",
        "defaultsetting": {
          "singleSelection": true,
          "allowSearchFilter": true,
          "checkBoxRequired": false,
          "closeDropDownOnSelection": true,
          "apliCall": true,
          "advancesearch": {
            "resource": "duty_roster_advSearch",
          }
        },
        "datasource": {
          "application": "facility-management",
          "resource": "duty_roaster",
          "query_id": "GET_NURSE_BY_WARD",
          "args": "department_id:" + this.formValue.department_id + ",location:" + this.formValue.ward_name + ",locationType:" + this.formValue.wardType_id
        },
        "name": "nurse_id"
      }
      let objNurse = {
        "component": "hidden",
        "name": "nurse_name",
      }
      if (this.action == 'DUTY_ROSTER_CREATION' || this.action == 'DUTY_') {
        this.container.dynamicColumns.unshift(obj);
      }
      this.container.dynamicColumns.unshift(objNurse);
      this.isLoaded = false;
      this.gridConfig = {
        items: [{ nurse_id: '' }],
        paging: false,
        move_item: false,
        dynamiColumns: this.container.dynamicColumns
      }
      if (this.action != 'DUTY_ROSTER_CREATION' && this.autoFillItem != '') {
        this.gridConfig.items = this.autoFillItem;
      }
      this.isLoaded = true;
    }
  }

  getLabel(i: any, dateM: any) {
    let d = Number(dateM);
    var date = new Date(d);
    this.month = date.getMonth();
    this.year = date.getFullYear();
    var FirstDay = new Date(this.year, this.month, i).getDay();
    let weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var firstDay = weekday[FirstDay];
    return i + '-' + firstDay;
  }

  getMonthDays(i: any) {
    let d = Number(i)
    var dt = new Date(d);
    this.month = dt.getMonth();
    this.year = dt.getFullYear();
    var daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
    return daysInMonth
  }
  getDate(i) {
    var dt = new Date(i);
    let day = dt.getDate();
    return day
  }

  questionValueChanged(event: any) {
    this.formValue = event.form.value;
    if (event.question.question.key == "department_id" && this.formValue != undefined && this.formValue.department_id) {
      this.getShiftLeave(this.formValue.department_id);
    }
    if (this.action != 'WARD_CHANGE' && this.formValue.month && event && event.question && event.question.question && (event.question.question.key == "month" || event.question.question.key == "ward_id")) {
      this.container.dynamicColumns = [];
      for (let i = 1; i < this.getMonthDays(this.formValue.month) + 1; i++) {
        if (this.action != 'SHIFT_CHANGE' && this.action != 'DUTY_') {
          let fields = {
            "label": this.getLabel(i, this.formValue.month),
            "getterKey": "text",
            "getterValue": "text",
            "class_name": "kx-control col-12",
            "order": i,
            "type": "String",
            "disabled": this.currentMonth == this.month && this.currentYear == this.year && this.currentDate > i,
            "component": "dropdown",
            "datasource": {
              possible_value: this.shiftList
            },
            "name": "leave_code" + i
          }
          this.container.dynamicColumns.push(fields);
        }
        if (this.action == 'SHIFT_CHANGE' || this.action == 'DUTY_') {
          let fields = {
            "label": this.getLabel(i, this.formValue.month),
            "getterKey": "text",
            "getterValue": "text",
            "class_name": "kx-control col-12",
            "order": i,
            "type": "String",
            "component": "dropdown",
            "disabled": this.currentMonth == this.month && this.currentYear == this.year && this.currentDate > i,
            "datasource": {
              "application": "facility-management",
              "resource": "duty_shift_master",
              "query_id": "GET_SHIFT_AND_LEAVE",
              "args": "status:active,department:" + this.formValue.department_id
            },
            "name": "leave_code" + i
          }
          this.container.dynamicColumns.push(fields);
        }
      }
      this.prepareDynamicolumns(event)
    }
    if (this.action == 'WARD_CHANGE' && this.formValue.month && event && event.question && event.question.question && event.question.question.key == "des_ward_id") {
      var dt = new Date(this.formValue.month);
      this.month = dt.getMonth();
      this.year = dt.getFullYear();
      var daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
      this.container.dynamicColumns = [];
      for (let i = 1; i < daysInMonth + 1; i++) {
        let fields = {
          "label": this.getLabel(i, this.formValue.month),
          "getterKey": "text",
          "getterValue": "text",
          "class_name": "kx-control col-12",
          "order": i,
          "type": "String",
          "disabled": this.currentMonth == this.month && this.currentYear == this.year && this.currentDate > i,
          "component": "dropdown",
          "datasource": {
            possible_value: this.shiftList
          },
          "name": "leave_code" + i
        }
        this.container.dynamicColumns.push(fields);
      }
      this.prepareDynamicolumns(event)
    }
    if (event && event.form && event.form.value.department_id && event.form.value.ward_name && event.form.value.wardType_id && event.question.question.key == "ward_name") {
      this.getNurseData(event);
    }
  }

  getTypeShift(item: any) {
    let obj = this.shiftList != undefined && this.shiftList != "" ? this.shiftList.find(x => x.text == item) : '';
    return obj != undefined ? obj.id : ''
  }

  getMDate(key: String) {
    let i: any;
    if (key.length > 11)
      i = key[key.length - 2] + key[key.length - 1]
    else
      i = key[key.length - 1]
    return this.getLabel(i, this.formValue.month)
  }

  saveDatta(finalObj: any, finalKey: any) {
    if (this.formValue.department_id == '' || this.formValue.ward_id == '' || this.formValue.nurse_id == '' || this.formValue.month_code == '' || this.formValue.wardType_id == '') {
      this.alertService.error("Please Fill All Required Details");
      this.loader.hideSpinner();
      return;
    }
    if (this.getData != undefined && (this.formValue.des_ward_id == '' || this.formValue.des_wardType_id == '')) {
      this.alertService.error("Please Fill All Required Details");
      this.loader.hideSpinner();
      return;
    }
    let obj = {
      "duty_roaster": finalObj
    }
    if (this.action == 'DUTY_') {
      this.action = 'DUTY_ROSTER_CREATION';
    }
    this.baseService.action(obj, this.action, 'facility-management', 'duty_roaster').subscribe((result) => {
      if (result.message.toLowerCase() == "success") {
        this.loader.hideSpinner();
        this.back();
      } else {
        this.loader.hideSpinner()
        this.alertService.error(result.message)
      }
      (err) => {
        this.loader.hideSpinner()
        console.error("error in getting data :: ", err)
      }
    })
  }
  saveData(finalKey: any) {
    this.loader.showSpinner()
    let finalObj: any = [];
    let dateFields: any = this.someInput;
    this.dateFields = dateFields != undefined ? dateFields._editableGridData.items : '';
    let nurse: any;
    let nurse_name: any;
    let shiftLeaveList = [];
    for (let i in this.dateFields) {
      for (let key in this.dateFields[i]) {
        if (this.dateFields[i].hasOwnProperty(key) && key != 'nurse_id') {
          if (this.dateFields[i][key]) {
            let fields = {
              "date": this.getMDate(key),
              "shift": this.dateFields[i][key],
              "type_": this.getTypeShift(this.dateFields[i][key]),
              "ward_id": this.formValue.ward_id,
              "ward_name": this.formValue.ward_name,
              "wardType_id": this.formValue.wardType_id,
              "wardType_name": this.formValue.wardType_name
            }
            shiftLeaveList.push(fields);
          }
        }
        else {
          nurse = this.dateFields[i][key];
          nurse_name = this.dateFields[i]['nurse_name'];
        }
      }
      let obj = {
        "department_id": this.formValue.department_id,
        "department_name": this.formValue.department_name,
        "ward_id": this.formValue.ward_id,
        "ward_name": this.formValue.ward_name,
        "wardType_id": this.formValue.wardType_id,
        "des_ward_id": this.formValue.des_ward_id,
        "des_ward_name": this.formValue.des_ward_name,
        "des_wardType_name": this.formValue.des_wardType_name,
        "des_wardType_id": this.formValue.des_wardType_id,
        "nurse_id": nurse ? nurse : this.getData ? this.getData.nurse_id : '',
        "nurse_name": nurse_name ? nurse_name : this.getData ? this.getData.nurse_name : '',
        "wardType_name": this.formValue.wardType_name,
        "store_id": this.formValue.store_id,
        "month": this.formValue.month,
        "year": this.year,
        "stage": finalKey,
        "month_code": this.getMonth(this.month),
        "destination": this.getDestination(finalKey),
        "shift_array": shiftLeaveList
      }
      // finalObj.push(obj);
      const pos = finalObj.findIndex(i => this.isSameItem(i, obj, 'nurse_id'));
      if (pos === -1)
        finalObj.push(obj);
      else {
        this.alertService.error("Duplicates Staff Name Not allowed");
        this.loader.hideSpinner();
        return;
      }
      shiftLeaveList = [];
    }
    if (finalObj.length > 0 && (nurse || (this.getData && this.getData.nurse_id))) {
      this.saveDatta(finalObj, finalKey)
    }
    else {
      this.alertService.error("Please Fill All Required Details");
      this.loader.hideSpinner();
    }
  }

  getDestination(finalKey: any) {
    if (this.action != 'WARD_CHANGE') {
      return this.formValue.department_id + " " + this.formValue.ward_id + " " + this.formValue.wardType_id + " " + this.formValue.month + " " + finalKey;
    }
    if (this.action == 'WARD_CHANGE') {
      return this.formValue.department_id + " " + this.formValue.des_ward_id + " " + this.formValue.des_wardType_id + " " + this.formValue.month + " " + finalKey;
    }
  }

  getMonth(i: any) {
    let month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return month_names[i];
  }

  startValue(event) {
    this.filterDate.FROM = event
  }
  endValue(event) {
    this.filterDate.TO = event
  }

  applyFilter() {
    if (this.filterDate.FROM && this.filterDate.TO) {
      var sd = new Date(this.filterDate.TO);
      var ed = new Date(this.filterDate.FROM);
      if (this.month == sd.getMonth() && this.month == ed.getMonth()) {
        if (this.filterDate.FROM < this.filterDate.TO || this.filterDate.FROM == this.filterDate.TO)
          this.dynamicFields(this.filterDate)
        else
          this.alertService.error("End Should be grater than Start Date");
      }
      else
        this.alertService.error("Please Select Correct Month");
    }
    else
      this.alertService.error("Please Select Both Date");
  }

  getClass(item, field) {
    let value = item.shift_array != undefined ? item.shift_array.find(x => x.date == field.expression) : '';
    if (value != undefined && value['status'] != undefined && value['status'] == 'inactive') {
      return 'inactive-shift';
    }
    if (value != undefined && value['updated'] != undefined && value['updated'] == true) {
      return 'updated-shift';
    }
  }

  private isSameItem(i1: any, i2: any, key: any): boolean {
    return this.getNestedValue(i1, key) === this.getNestedValue(i2, key);
  }

  private getNestedValue(obj: any, key: string): any {
    if (obj[key] != undefined)
      obj = obj[key];
    return obj;
  }

  back() {
    this.route.queryParams.subscribe((urlParams) => {
      this.router.navigateByUrl(urlParams.returnUrl);
    })
  }
  // For Print
  onBulkActionClicked() {
    let gridFields = [];
    for (let i = this.startIteration; i < this.endIteration; i++) {
      let heading = {
        "heading": "" + i + "",
        "value": "",
        "format": "",
        "type": "String",
        "getterArrayKey": "",
        "name": "_" + i
      }
      gridFields.push(heading)
    }
    let ob2 = {
      "heading": "Nurse",
      "type": "string",
      "value": "",
      "name": "nurse_name",
      "format": "",
      "getterArrayKey": ""
    }
    gridFields.unshift(ob2)
    let obj = {
      "heading": "Ward",
      "type": "string",
      "value": "",
      "name": "ward_name",
      "format": "",
      "getterArrayKey": ""
    }
    gridFields.unshift(obj)
    let action_obj = {
      action: "print",
      items: {
        action: "print",
        class: "fa fa-print",
        label: "field.label.print",
        permission_required: false,
        file_data: {
          action: "print",
          file_type: "pdf",
          filterPrintInfo: false,
          gridInfo: gridFields,
          bannerInfo: [
            {
              heading: "Department ",
              name: "department_name",
              type: "string",
              value: this.dutyRoster.view['department_name']
            },
            {
              heading: "Ward Type ",
              type: "string",
              name: "wardType_name",
              value: this.dutyRoster.view['wardType_name']
            },
            {
              heading: "Ward ",
              name: "ward_name",
              type: "string",
              value: this.dutyRoster.view['ward_name']
            },
            {
              heading: "Year ",
              name: "year",
              type: "string",
              value: this.dutyRoster.view['year']
            },
            {
              heading: "Month ",
              name: "month_code",
              type: "string",
              value: this.dutyRoster.view['month_code']
            }
          ]
        }
      }
    }
    if (typeof action_obj.action == "string" && ['print', 'download', 'view_file'].indexOf(action_obj.action) > -1) {
      var menuObj = { actionType: JSON.parse(JSON.stringify(action_obj)).items, data: {} };
      if (menuObj.actionType.file_data.actionType && menuObj.actionType.file_data.actionType == 'downloadAll') {
        menuObj.actionType.file_data.page_size = 0;
      }
      if (menuObj.actionType.file_data.gridInfo != undefined) {
        menuObj.actionType.file_data.gridHeading = this.baseService._currentTitle;
        if (this.resourceDef.list.hasOwnProperty('APIresource')) {
          this.bindGrid(this.resourceDef.list.APIresource.datasource.resource, this.resourceDef.list.APIresource.datasource.application, '', this.resourceDef.list.APIresource.datasource.query_id, menuObj.actionType.file_data);
        }
      }
    }
  }

  bindGrid(resource?, application?, type?, queryId?, printInfo?, callback = null) {
    this.loader.showSpinner();
    let GridData = {
      filter: "",
      page_size: 10
    }
    var gridData = JSON.parse(JSON.stringify(GridData));//making a clone
    gridData['query_id'] = queryId != undefined ? queryId : "GET_ROASTER_BY_DESTINATION_DATEWISE";
    //implementing print
    if (printInfo) {
      if (printInfo.contentType != 'byte_array') {
        printInfo.responseType = "blob";
        var gridTemplate = 'grid';
        var args = "reportTemplateId:" + gridTemplate + ",contentType:" + printInfo.file_type + ",destination:" + this.route.snapshot.params.id;
        if (this.appService.getCurrentLocation() && this.appService.getCurrentLocation().location_id != undefined) {
          args = args + ',location_id:' + this.appService.getCurrentLocation().location_id;
        }
        if (gridData.args != undefined && gridData.args != "") {
          gridData.args = gridData.args + ',' + args;
        } else {
          gridData.args = args;
        }
      }

      gridData.printInfo = printInfo;
    }
    //this will work for normal case
    if (printInfo) {
      this.bindGridWithPrint(gridData, "", resource, application, printInfo, callback);
    }
  }

  bindGridWithPrint(gridData, val, resource, application, printInfo, callback) {
    gridData = this.baseService.encodeURIPrintGridData(gridData);
    let obj = {
      queryId: gridData.query_id,
      args: gridData.args != undefined ? gridData.args : "",
      amount: gridData.amount != undefined ? btoa(JSON.stringify(gridData.amount)) : '',
      filter: gridData.filter != undefined ? gridData.filter : "",
      contentType: gridData.printInfo != undefined && gridData.printInfo.file_type != undefined ? gridData.printInfo.file_type : "",
      gridInfo: gridData.printInfo != undefined && gridData.printInfo.gridInfo != undefined ? btoa(JSON.stringify(gridData.printInfo.gridInfo)) : "",
      bannerInfo: gridData.printInfo != undefined && gridData.printInfo.bannerInfo != undefined ? btoa(JSON.stringify(gridData.printInfo.bannerInfo)) : "", bannerData: gridData.printInfo != undefined && gridData.printInfo.bannerData != undefined ? gridData.printInfo.bannerData : "", page_no: gridData.page_no, page_size: gridData.page_size, gridHeading: this.baseService._currentTitle != undefined ? this.baseService._currentTitle : "",
      search: gridData.search != undefined ? gridData.search : "",
      search_columns: gridData.searchColumns != undefined ? gridData.searchColumns : "",
      filterPrintInfo: gridData && gridData.printInfo != undefined && gridData.printInfo.filterPrintInfo != undefined && gridData.printInfo.filterPrintInfo ? btoa(JSON.stringify(gridData.printInfo.filterPrintInfo)) : false
    };
    /*********ForBulk download */
    let responseType = "blob";
    let resource_ = "duty_roaster/print";
    this.baseService.action(obj, "", application, resource_, "", { responseType: responseType, printApplication: true }).subscribe(
      (data: any) => {
        if (printInfo) {
          if (data.errCode != undefined && data.errCode == -9) {
            //do nothing
          } else { this.printService.handleFileReponse({ contentType: printInfo.file_type, key: this.baseService._currentTitle }, printInfo.action, data); }
        } else {
          //if not print
          if (data.errCode == -1) {
            this.alertService.error(data.message);
            if (callback)
              callback(false);
          } else {
            if (callback)
              callback(gridData);
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alertService.error('API error');
        this.loader.hideSpinner();
        if (callback)
          callback(false);
      }
    );
  }
}
